import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {PremiumCalculation} from './premium-calculation.model';
import {DWPValidatorsService} from '../../dwpvalidators.service';
import np from 'number-precision';
import {HttpService} from '../../services/http.service';
import {DecimalUtil} from '../../components/commons/util/decimal-util';

@Component({
  selector: 'app-premium-calculation',
  templateUrl: './premium-calculation.component.html',
  styleUrls: ['./premium-calculation.component.css']
})
export class PremiumCalculationComponent implements OnInit {

  @Input()
  calculatedRate: number;
  @Input()
  contractCode: number;
  @Input()
  deliveryDate: Date;
  @Output()
  atPremiumCalculation: EventEmitter<PremiumCalculation> = new EventEmitter<PremiumCalculation>();
  form: UntypedFormGroup;
  minimumFee: number;
  amountToBeCharged = 0;
  discountAmount: number;
  premiumCalculation: PremiumCalculation;
  constructor(private formBuilder: UntypedFormBuilder, private validationService: DWPValidatorsService, public http: HttpService,
              public decimalUtil: DecimalUtil) {
    this.form = this.formBuilder.group({
      penaltyOrDiscount: new UntypedFormControl('0',
        [validationService.number, Validators.required, Validators.min(-10000), Validators.max(10000)])
    });
  }

  ngOnInit(): void {
    this.getMinimumFee();
    if (!this.calculatedRate) {
      this.calculatedRate = 0;
    }
    this.calculateAmountToBeCharged();
    this.emit();
  }

  calculateAmountToBeCharged(): number {
    const penaltyOrDiscountString: string = this.form.get('penaltyOrDiscount').value;

    if (isNaN(parseFloat(penaltyOrDiscountString)) || isNaN(this.calculatedRate)) {
      this.amountToBeCharged = null;
    } else {
      const penaltyOrDiscount: number = parseFloat(penaltyOrDiscountString);
      this.amountToBeCharged = np.plus(np.round(penaltyOrDiscount, 2), np.round(this.calculatedRate, 2));

      if (this.amountToBeCharged !== 0 && this.amountToBeCharged < this.minimumFee){
        this.amountToBeCharged = this.minimumFee;
      }
    }

    return this.amountToBeCharged;
  }


  emit(): void {

    this.calculateAmountToBeCharged();
    if (this.form.valid) {
      this.premiumCalculation = {
        calculatedRate: this.calculatedRate,
        penaltyOrDiscount: parseFloat(this.form.get('penaltyOrDiscount').value),
        amountToBeCharged: this.amountToBeCharged,
      };
      this.atPremiumCalculation.emit(this.premiumCalculation);
    } else {
      this.atPremiumCalculation.emit(null);
    }
  }

  getMinimumFee(){
    this.http.getMinimumFee(this.contractCode, this.deliveryDate).subscribe((res) => {
      this.minimumFee = res;
    });
  }

}
